module.exports = __webpack_public_path__ + "img/store.04c4fac3.png";